import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useRef } from 'react';
import {
  Card,
  Stack,
  Button,
  Popover,
  MenuItem,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
  FormControl,
  Divider,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Iconify from '../components/iconify';
import * as React from 'react';
import Services from 'src/services/Services';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import AddEditUserModal from 'src/modals/AddEditUserModal';
import './userPage.css';
import useMediaQuery from '@mui/material/useMediaQuery';
import FilterButton from 'src/components/shared/FilterButton';
import ClearButton from 'src/components/shared/ClearButton';
import UserStatusFilters from 'src/components/shared/UserStatusFilters';
import DynamicTable from 'src/components/shared/DynamicTable';
import CustomFilter from 'src/components/filter/CustomFilter';
import FilterViewButton from 'src/components/shared/FilterViewButton';
import EditButton from 'src/components/shared/EditButton';
import { useLocalization } from 'src/context/LocalizationContext';
import ExportToExcelButton from 'src/components/shared/ExportToExcelButton';
import api from 'src/services/BaseService';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function UserPage() {

  const { language } = useLocalization();

  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState('');
  const [open, setOpen] = useState(null);
  const [mobileFilterModal, setMobileFilterModal] = useState(false);


  const [rows, setRows] = useState([]);
  const [allDatas, setAllDatas] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState('user');

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [userID, setUserID] = useState('');
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [firstResponsibleOffice, setFirstResponsibleOffice] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isUserDialogOpen, setUserDialogOpen] = useState(false);
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [actionType, setActionType] = useState('new');
  const [lastData, setLastData] = useState(false);
  const [status, setStatus] = useState(true);
  const [epChecked, setEpChecked] = useState(false);
  const [epsChecked, setEpsChecked] = useState(false);

  const [resetLoading, setResetLoading] = useState(false);
  const [modalStep, setModalStep] = useState(0);
  const [selectedUser, setSelectedUser] = useState({ id: null, name: '', phone: '' });
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [modalError, setModalError] = useState('');

  const usernameRef = useRef(null);
  const nameRef = useRef(null);
  const dotRef = useRef(null);


  const [filterModal, setFilterModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const handleModal = () => {
    setFilterModal(true);
  };

  const handleCloseModalFilter = () => {
    setFilterModal(false);
  };
  const TABLE_HEAD = [

    { id: 'name', label: language.commons.column.name, alignRight: false },
    { id: 'lastname', label: language.commons.column.surname, alignRight: false },
    { id: 'phone', label: language.commons.labels.phone, alignRight: false },
    { id: 'email', label: language.commons.column.email, alignRight: false },
    { id: 'branch_code', label: "Şube Kodu", alignRight: false },
    { id: 'phoneType', label: "Telefon Türü", alignRight: false },
    { id: 'appType', label: "Uygulama Türü", alignRight: false },
    { id: 'appVersion', label: "Uygulama Versiyonu", alignRight: false },
    {
      id: 'allowedPoints', label: language.commons.column.point2, alignRight: false, format: (value, row) => {
        if (Array.isArray(row.allowedPoints)) {
          return (
            row?.allowedPoints?.map((point, index) => (
              <Typography style={{ fontSize: 13 }} key={index}>
                {point.title}
                {index < row?.allowedPoints?.length - 1 ? ', ' : ''}
              </Typography>)
            ))
        }
        else {
          return <span>-</span>
        }
      }
    },
    {
      id: 'sendPassword',
      label: 'Şifre Gönder',
      alignRight: false,
      format: (value, row) => (
        <Button
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            handlePasswordResetClick(row);
          }}
        >
          Yeni Şifre Gönder
        </Button>
      ),
    },
    {
      id: 'actions', label: '', alignRight: false, format: (value, row) =>
        <EditButton
          onClick={() => {
            setActionType('edit');
            setUserID(row.id);
            setUserDialogOpen(true);
            setLastData(true);
          }}
        />


    },

  ]

  const handleCloseMenu = () => {
    setOpen(null);
    setPassword('');
  };

  const handleCloseModal = () => {
    setName('');
    setLastname('');
    setUsername('');
    setEmail('');
    setPhone('');
    setPassword('');
    setSelectedRoles([]);
    setSelectedLocations([]);
    setFirstResponsibleOffice(null);
    setSelectedUserType('user');
    setUserDialogOpen(false);
    setMobileFilterModal(false);
  };

  const handleCopyPassword = () => {
    navigator.clipboard
      .writeText(password)
      .then(() => {
        // console.log('Şifre kopyalandı:', password);
      })
      .catch((err) => {
        console.error('Şifre kopyalanırken bir hata oluştu:', err);
      });
  };

  // const handleResetPassword = () => {
  //   setResetLoading(true);
  //   api
  //     .post('flow/user-forced-reset-password', {
  //       // email: '',
  //       userID: userID,
  //     })
  //     .then((response) => {
  //       if (response.data) {
  //         setPassword(response.data.result);
  //         setPasswordDialog(true);
  //       } else {
  //         toast.error(response.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       toast.error(error.message);
  //     })
  //     .finally(() => setResetLoading(false));
  // };
  
  let nameUsernames = [];
  const handleFilterByUsername = (text) => {
    const _username = text.toLowerCase();
    const filteredDatas = allDatas.filter((item) =>
      item.username.toLowerCase().includes(_username)
    );
    nameUsernames = filteredDatas;
    //setRows(filteredDatas);
  };

  let filterNames = [];
  const handleFilterByName = (text) => {
    const _name = text.toLowerCase();
    const filteredDatas = allDatas.filter((item) =>
      `${item.name.toLowerCase()} ${item.lastname.toLowerCase()}`.includes(
        _name
      )
    );
    filterNames = filteredDatas;
    //setRows(filteredDatas);
  };

  let filterDots = [];
  const handleFilterByDot = (text) => {
    const _dot = text.toLocaleLowerCase("tr");
    const filteredDatas = allDatas.filter((item) =>
      Array.isArray(item.allowedPoints) &&
      item.allowedPoints.some((point) =>
        point.title?.toLocaleLowerCase("tr").includes(_dot)
      )
    );
    filterDots = filteredDatas;
    //setRows(filteredDatas);
  };
  const clearFilters = () => {
    const dotRefInputElement = dotRef.current.querySelector('input');
    const userNameRefInputElement = usernameRef.current.querySelector('input');
    const nameRefInputElement = nameRef.current.querySelector('input');

    if (usernameRef.current) {
      userNameRefInputElement.value = '';
    }
    if (nameRef.current) {
      nameRefInputElement.value = '';
    }
    if (dotRef.current) {
      dotRefInputElement.value = '';
    }

    setEpChecked(false);
    setEpsChecked(false);

    setRows(allDatas);
  };

  const getFilteredUserList = () => {
    let combinedResults = [];

    if (Array.isArray(nameUsernames)) {
      combinedResults = [...combinedResults, ...nameUsernames];
    }

    if (Array.isArray(filterNames)) {
      combinedResults = [...combinedResults, ...filterNames];
    }

    if (Array.isArray(filterDots)) {
      combinedResults = [...combinedResults, ...filterDots];
    }

    if (epChecked) {
      const epResults = allDatas.filter((item) => item.isEasypoint === "1");
      combinedResults = [...combinedResults, ...epResults];
    }

    if (epsChecked) {
      const epsResults = allDatas.filter((item) => item.isEsnaf === "1");
      combinedResults = [...combinedResults, ...epsResults];
    }

    const uniqueResults = Array.from(new Set(combinedResults));

    setRows(uniqueResults);
  };

  useEffect(() => {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    // console.log(parsedUser);
    setToken(parsedUser.token);

    setLoading(true);
    // Kullanıcılar
    Services.GetUsers(parsedUser.token, status)
      .then((res) => {
        if (res.data.status) {
          const rowsWithNo = res?.data?.result?.map((row, index) => ({
            ...row,
            no: index + 1,
          }));
          setUsers(res.data.result);
          console.log(rowsWithNo)

          setRows(rowsWithNo);
          setAllDatas(rowsWithNo);
        } else {
          setAllDatas([]);
          setRows([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setRows([]);
        setAllDatas([]);
      })
      .finally(() => setLoading(false));
  }, [password, status]);



  function exportToExcel() {
    let temp1 = users.map((x, index) => {
      let a = {
        id: index + 1,
        name: x.name,
        lastname: x.lastname,
        phone: x.phone,
        email: x.email,
        branchCode: x.branch_code,
        point: Array.isArray(x.allowedPoints) && x.allowedPoints.length > 0
          ? x.allowedPoints.map(e => e.title).join(', ')
          : 'No Points',
        userID: x.id,
        phoneType: x.phoneType ? x.phoneType : "-",
        appType: x.appType ? x.appType : "-",
        appVersion: x.appVersion ? x.appVersion : "-"
      };
      return a;
    });


    api
      .post('excel/export', {
        type: 'excel',
        content: temp1,
        header: {
          No: 'number',
          'Ad': 'string',
          'Soyad': 'string',
          'Telefon': 'string',
          'Email': 'string',
          'Şube Kodu': 'string',
          'Nokta': 'string',
          'Id': 'string',
          "Telefon Türü": 'string',
          "Uygulama Türü": 'string',
          "Uygulama Versiyonu": 'string'
        },
      })
      .then((response) => {
        if (response.data.status) {
          try {
            const newWindow = window.open(response.data.result, '_blank');
            if (
              !newWindow ||
              newWindow.closed ||
              typeof newWindow.closed == 'undefined'
            ) {
              throw new Error(
                'Pop-up engellendi. Lütfen pop-up engelleyicisini devre dışı bırakın.'
              );
            }
          } catch (e) {
            console.log("error fetch data", e);
          }
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }


  const handleModalClose = () => {
    setModalStep(0);
    setSelectedUser({ id: null, name: '', phone: '' });
    setNewPhoneNumber('');
    setResetLoading(false);
    setModalError('');
  };

  const handlePasswordResetClick = (user) => {
    setSelectedUser(user);
    setNewPhoneNumber(user.phone || '');
    setModalStep(1);
  };

  const handleSendSms = async () => {
    setResetLoading(true);
    setModalError('');
    try {
      const response = await api.post('flow/reset-password-and-send-sms', {
        userID: selectedUser.id,
      });
      if (response.data.status) {
        setModalStep(3);
      } else {
        setModalError(response.data.message || 'SMS gönderilirken bir hata oluştu.');
      }
    } catch (error) {
      setModalError(error.message || 'Sunucu hatası. SMS gönderilemedi.');
    } finally {
      setResetLoading(false);
    }
  };

  const handleUpdateAndSendSms = async () => {
    if (newPhoneNumber.length < 10) {
      setModalError('Lütfen geçerli bir telefon numarası girin.');
      return;
    }

    setResetLoading(true);
    setModalError('');

    try {
      const userResponse = await Services.GetUser(token, selectedUser.id);
      if (!userResponse.data.status) {
        throw new Error('Kullanıcı verileri çekilemedi.');
      }

      const userData = userResponse.data.result;
      const preservedAllowedPoints = Array.isArray(userData?.allowedPoints)
        ? userData.allowedPoints
          .filter((point) => point?.id != null)
          .map((point) => ({
            id: point.id,
            isFirstResponsible:
              point?.isFirstResponsible === true ||
              point?.isFirstResponsible === 1 ||
              point?.isFirstResponsible === '1' ||
              point?.firstResponsible === true ||
              point?.firstResponsible === 1 ||
              point?.firstResponsible === '1',
          }))
        : [];

      const body_data = {
        userID: selectedUser.id,
        type: userData.type,
        name: userData.name,
        lastname: userData.lastname,
        email: userData.email,
        phone: newPhoneNumber,
        username: userData.username,
        password: userData.password || undefined,
        allowedPoints: preservedAllowedPoints,
        isAdministrator:
          userData.isAdministrator === true ||
          userData.isAdministrator === 1 ||
          userData.isAdministrator === '1',
        frontAuth: Array.isArray(userData.frontAuth) ? userData.frontAuth : [],
        status:
          userData.status === true ||
          userData.status === 1 ||
          userData.status === '1',
      };

      const updateResponse = await Services.UpdateProfile(token, body_data);
      if (updateResponse.data.status) {
        await handleSendSms();
      } else {
        throw new Error(updateResponse.data.message || 'Profil güncellenemedi.');
      }

    } catch (error) {
      setModalError(error.message);
      setResetLoading(false);
    }
  };


  return (
    <>
      <Helmet>
        <title> {language.user_page.titles.site_title} </title>
      </Helmet>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}

      >
        <Stack

        >
          <Typography className="ml-2" variant="h4" gutterBottom>
            {language.user_page.titles.title}
          </Typography>
        </Stack>

        <Stack direction={isMobile ? 'column' : 'row'}
          spacing={2}
          paddingX={1}
          alignItems="end">
          <AddEntityButton
            onClick={() => {
              setActionType('new');
              setUserDialogOpen(true);
            }}
            label={language.commons.add_user}
            icon={'ic:outline-add'}
          />
          <ExportToExcelButton
            sx={{ marginLeft: '8px' }}
            onClick={() => exportToExcel()}
          />
        </Stack>

      </Stack>
      {loading ?
        <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
          <CircularProgress size={24} color="inherit" />
        </div> :

        <>

          <Stack
            direction="row"
            justifyContent={isMobile ? 'space-between' : 'end'}
            mb={5}
            paddingX={2}
          >
            {isMobile ? (
              <FilterViewButton variant="contained" onClick={handleModal} />
            ) : null}
          </Stack>
          <Card className="mobile_horizantal">
            <CustomFilter
              modalType={'drawer'}
              filterModal={filterModal}
              handleCloseModal={handleCloseModalFilter}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="flex-start"
                paddingY={2}
                paddingX={1}
                spacing={2}
                width="100%"
              >
                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    ref={nameRef}
                    label={language.commons.column.name_surname}
                    variant="outlined"
                    autoComplete="off"
                    onChange={(e) => handleFilterByName(e.target.value)}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    ref={usernameRef}
                    label={language.commons.labels.username}
                    variant="outlined"
                    autoComplete="off"
                    onChange={(e) => handleFilterByUsername(e.target.value)}
                  />
                </FormControl>

                <FormControl component="fieldset" sx={{ flex: 1, minWidth: '100%' }}>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={epChecked}
                          onChange={(e) => {
                            setEpChecked(e.target.checked);
                          }}
                        />
                      }
                      label="EP"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={epsChecked}
                          onChange={(e) => {
                            setEpsChecked(e.target.checked);
                          }}
                        />
                      }
                      label="EPS"
                    />
                  </FormGroup>
                </FormControl>

                <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                  <TextField
                    ref={dotRef}
                    label={language.commons.column.point_name}
                    variant="outlined"
                    autoComplete="off"
                    onChange={(e) => handleFilterByDot(e.target.value)}
                  />
                </FormControl>

                <div
                  style={{
                    height: '20px',
                    width: '1px',
                    backgroundColor: '#EAECF0',
                    margin: '0 15px',
                    marginLeft: '15px',
                  }}
                ></div>
                <Stack>
                  <UserStatusFilters
                    activeOnClick={() => setStatus(true)}
                    passiveOnClick={() => setStatus(false)}
                  />
                </Stack>
                <Divider sx={{ width: '100%' }} />
                <Stack direction="row">
                  <ClearButton onClick={() => clearFilters()} />
                  <FilterButton onClick={() => getFilteredUserList()} />
                </Stack>

              </Stack>

            </CustomFilter>

            <DynamicTable
              data={rows}
              headers={TABLE_HEAD}
              initialOrder={'name'}
              initalOrderDirection={'desc'}
              isOrdered={true}
              isMobile={isMobile}
              handleModal={handleModal}
              handleCloseModal={handleCloseModalFilter}
              rowOnClick={(row) => {
                setActionType('edit');
                setUserID(row.id);
                setUserDialogOpen(true);
                setLastData(true);
              }}

            />
          </Card>

          <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setActionType('edit');
                setUserDialogOpen(true);
              }}
            >
              <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
              {language.commons.edit}
            </MenuItem>
          </Popover>

          <AddEditUserModal
            userID={userID}
            isUserDialogOpen={isUserDialogOpen}
            // handleCloseModal={handleCloseModal}
            actionType={actionType}
            setUserDialogOpen={setUserDialogOpen}
            MenuProps={MenuProps}
          />

          <Dialog
            open={passwordDialog}
            onClose={() => {
              setPasswordDialog(false);
              setPassword('');
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{'Yeni Şifre'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {language.components.AddEditUserModal.refresh_password}
              </DialogContentText>
              <br />
              <DialogContentText
                disabled
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 1,
                }}
                id="alert-dialog-description"
              >
                <TextField
                  disabled
                  fullWidth
                  type="text"
                  label={language.commons.labels.password}
                  name="password"
                  value={password}
                  margin="normal"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button onClick={handleCopyPassword}>
                          <ContentCopyIcon color="action" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setPasswordDialog(false)}>{language.commons.close}</Button>
            </DialogActions>
          </Dialog>
          {/* --- ŞİFRE GÖNDERME MODALI --- */}
          <Dialog open={modalStep > 0} onClose={handleModalClose} maxWidth="xs" fullWidth>
            {modalStep === 1 && (
              <>
                <DialogTitle>Yeni Şifre Gönderme Talebi</DialogTitle>
                <DialogContent>
                  <Typography variant="body1" align="start" sx={{ mb: 1 }}>
                    Telefon numarası <strong>{selectedUser.phone}</strong> olan kullanıcıya SMS ile <strong>yeni şifre gönderme</strong> işlemini <strong>onaylıyor musunuz?</strong>
                  </Typography>
                  {modalError && <Typography color="error" align="start">{modalError}</Typography>}
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column', py: 1, px: 2, gap: 1 }}>
                  <Button onClick={handleSendSms} variant="contained" color="primary" fullWidth disabled={resetLoading} sx={{py: '11px'}}>
                    {resetLoading ? <CircularProgress size={24} /> : 'İşleme Devam Et'}
                  </Button>
                  <Button onClick={() => setModalStep(2)} variant="outlined" fullWidth sx={{py: '11px'}}>
                    Telefon Numarasını Güncelle
                  </Button>
                  <Button onClick={handleModalClose} variant="outlined" sx={{borderColor: '#000', color: '#000', py: '11px'}} fullWidth>
                    Vazgeç
                  </Button>
                </DialogActions>
              </>
            )}
            {/* --- 2. Adım: Telefon Güncelleme Ekranı --- */}
            {modalStep === 2 && (
              <>
                <DialogTitle>Yeni Şifre Gönderme Talebi</DialogTitle>
                <DialogContent>
                  <Typography variant="body1" align="start" sx={{ mb: 1}}>
                    Telefon numarası <strong>{selectedUser.phone}</strong> olan kullanıcıya SMS ile <strong>yeni şifre gönderme</strong> işlemini <strong>onaylıyor musunuz?</strong>
                  </Typography>
                  <TextField
                    fullWidth
                    label="Yeni Telefon Numarası"
                    value={newPhoneNumber}
                    onChange={(e) => setNewPhoneNumber(e.target.value)}
                    placeholder="+90 555 555 55 55"
                    margin="normal"
                  />
                  {modalError && <Typography color="error" align="center" sx={{ mt: 1 }}>{modalError}</Typography>}
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column', py: 1, px: 2, gap: 1 }}>
                  <Button onClick={handleUpdateAndSendSms} variant="contained" color="primary" fullWidth disabled={resetLoading} sx={{fontSize: 13, py: '11px' }}>
                    {resetLoading ? <CircularProgress size={24} /> : 'Telefon Numarasını Güncelle ve Gönder'}
                  </Button>
                  <Button onClick={handleModalClose} variant="outlined" sx={{borderColor: '#000', color: '#000', fontSize: 13, py: '11px'}} fullWidth>
                    Vazgeç
                  </Button>
                </DialogActions>
              </>
            )}
            {/* --- 3. Adım: Başarı Ekranı --- */}
            {modalStep === 3 && (
              <>
                <DialogTitle align="center">Yeni Şifre Başarıyla Gönderildi</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <CheckCircleOutline sx={{ fontSize: 60, color: 'green' }} />
                  <Typography variant="body1" align="center">
                    Telefon numarası <strong>{newPhoneNumber || selectedUser.phone}</strong> olan kullanıcıya SMS ile şifre gönderme işlemi başarıyla sağlanmıştır.
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                  <Button onClick={handleModalClose} variant="contained" fullWidth>
                    Tamam
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>
        </>
      }





    </>
  );
}
